import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const propTypes = {
    className: PropTypes.string,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            iconClass: PropTypes.string,
        })
    ),
};

const defaultProps = {
    links: [],
};

function BreadCrumbs(props) {
    let extraBcClass = '';
    const numLinks = props.links.length;
    let maxLengthForNoTitle;
    if (numLinks >=1 && numLinks <=4) {
        extraBcClass = `bc-li-${numLinks}`;
        switch (numLinks) {
            case 4: {
                maxLengthForNoTitle = 20;
                break;
            }
            case 3: {
                maxLengthForNoTitle = 30;
                break;
            }
            case 2: {
                maxLengthForNoTitle = 40;
                break;
            }
            case 1:
            default: {
                // nothing
            }
        }
    }

    return (
        <ul className={`bc-list ${props.className}`}>
            {props.links.map((link, idx) => {
                let extraAttrs = {};
                if (!!link.text && link.text.length > maxLengthForNoTitle) {
                    extraAttrs.title = link.text;
                }

                return (
                    <li className={`bc-li ${extraBcClass}`} key={idx}>
                        <Link to={link.href} {...extraAttrs}>
                            {link.iconClass &&
                                <span className={`margin-right-xs ${link.iconClass}`} aria-hidden="true" />
                            }
                            {link.text}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
}

BreadCrumbs.propTypes = propTypes;
BreadCrumbs.defaultProps = defaultProps;

export default BreadCrumbs;